"use strict";
// import { z } from 'zod';
Object.defineProperty(exports, "__esModule", { value: true });
// import { ISODateTimeSchema, UUIDSchema } from '../shared';
// export const ExemptionSchema = z.enum([
// 	'SKIP_RESUME_SCREENING',
// 	'SKIP_FIRST_INTERVIEW',
// 	'SKIP_FIRST_AND_SECOND_INTERVIEWS',
// ]);
// export const RecruitmentPolicySchema = z.enum([
// 	'CASUAL_INTERVIEW_ACCEPTED',
// 	'OPEN_APPLICATION_ACCEPTED',
// 	'PREVIOUS_SALARY_GUARANTEED',
// ]);
// export const OfferLetterTemplateSchema = z.object({
// 	id:           UUIDSchema,
// 	name:         z.string(),
// 	introduction: z.string(),
// 	message:      z.string(),
// 	subject:      z.string(),
// 	exemptions:   ExemptionSchema.array(),
// 	policies:     RecruitmentPolicySchema.array(),
// 	createdAt:    ISODateTimeSchema,
// 	updatedAt:    ISODateTimeSchema,
// });
